<template>
  <el-form class="edit-product-quotation__added-service view-quotation-details"
           ref="editForm"
           label-width="130px"
           size="small"
           :inline="true"
           @submit.native.prevent>
    <template v-if="addedServiceList && addedServiceList.length">
      <div class="form-card-box">
        <template v-for="(item,index) in addedServiceList">
          <el-radio-group v-model="addedServiceList[index].isPremium"
                          disabled
                          class="radio-group-row">
            <el-radio :label="item.id" v-for="item in isPremiumList" :key="item.id">{{item.name}}</el-radio>
          </el-radio-group>
          <el-form-item :label="item.name"
                        v-if="item.useDefaultTemplate"
                        class="">
                  <span slot="label"
                        class="service-name">{{item.name}}</span>
            <el-input v-model="addedServiceList[index].price"
                      disabled
                      class="edit-form__input3"
                      placeholder="请输入"></el-input>
            <span class="symbol input-after">{{item.priceUnitText}}</span>
          </el-form-item>
          <div class="the-form-item" v-else>
            <div class="the-form-item__label service-name">{{item.name}}</div>
            <div class="the-form-item__content">
              <!--VAT服务费-->
              <template v-if="item.code === 'FB014'">
                <span class="input-before">每票关税的</span>
                <el-form-item label="VAT服务费"
                              class="hide-label">
                  <el-input v-model="addedServiceList[index].price"
                            disabled
                            class="edit-form__input3"
                            placeholder="请输入"></el-input>
                  <span class="symbol input-after">%</span>
                </el-form-item>
              </template>
              <!--超重费-->
              <template v-if="item.code === 'FB017'">
                <span class="input-before">单件大于</span>
                <el-form-item label="超重(拒收阈值)"
                              class="hide-label">
                  <el-input v-model="addedServiceList[index].chargeLimit"
                            disabled
                            class="edit-form__input3"
                            placeholder="请输入"></el-input>
                </el-form-item>
                <span class="symbol input-after">KG拒收</span>
                <br/>
                <span class="input-before">单件大于</span>
                <el-form-item label="超重(大于)"
                              class="hide-label">
                  <el-input v-model="addedServiceList[index].chargeFrom"
                            disabled
                            class="edit-form__input3"
                            placeholder="请输入"></el-input>
                </el-form-item>
                <span class="symbol input-after">KG，</span>
                <span class="symbol input-after">小于</span>
                <el-form-item label="超重(小于)"
                              class="hide-label">
                  <el-input v-model="addedServiceList[index].chargeTo"
                            disabled
                            class="edit-form__input4"
                            placeholder="请输入"></el-input>
                </el-form-item>
                <span class="symbol input-after">KG，</span>
                <span class="symbol input-after">加收</span>
                <el-form-item label="超重费"
                              class="hide-label">
                  <el-input v-model="addedServiceList[index].price"
                            disabled
                            class="edit-form__input4"
                            placeholder="请输入"></el-input>
                </el-form-item>
                <span class="symbol input-after">RMB/件</span>
              </template>
              <!--超轻费-->
              <template v-if="item.code === 'FB018'">
                <span class="input-before">单件小于</span>
                <el-form-item label="超轻(小于)"
                              class="hide-label">
                  <el-input v-model="addedServiceList[index].minimumLimit"
                            disabled
                            class="edit-form__input3"
                            placeholder="请输入"></el-input>
                </el-form-item>
                <span class="symbol input-after">KG，</span>
                <span class="symbol input-after">加收</span>
                <el-form-item label="超轻费"
                              class="hide-label">
                  <el-input v-model="addedServiceList[index].price"
                            disabled
                            class="edit-form__input3"
                            placeholder="请输入"></el-input>
                </el-form-item>
                <span class="symbol input-after">RMB/件</span>
              </template>
              <!--一般贸易报关费-->
              <template v-if="item.code === 'FB019'">
                <span class="input-before">最低收费</span>
                <el-form-item label="报关费(最低)"
                              class="hide-label">
                  <el-input v-model="addedServiceList[index].minimumCharge"
                            disabled
                            class="edit-form__input3"
                            placeholder="请输入"></el-input>
                </el-form-item>
                <span class="input-after">RMB/票</span>
                <br/>
                <span class="input-before">每票大于</span>
                <el-form-item label="报关数(大于)"
                              class="hide-label">
                  <el-input v-model="addedServiceList[index].baseNum"
                            disabled
                            class="edit-form__input3"
                            placeholder="请输入"></el-input>
                </el-form-item>
                <span class="symbol input-after">品名，</span>
                <span class="symbol input-after">每增加一个品名收</span>
                <el-form-item label="报关费(加收)"
                              class="hide-label">
                  <el-input v-model="addedServiceList[index].price"
                            disabled
                            class="edit-form__input3"
                            placeholder="请输入"></el-input>
                </el-form-item>
                <span class="symbol input-after">RMB/件</span>
              </template>
              <!--偏远费-->
              <template v-if="item.code === 'FB020'">
                <el-form-item label="偏远费"
                              class="hide-label">
                  <el-input v-model="addedServiceList[index].price"
                            disabled
                            class="edit-form__input3"
                            placeholder="请输入"></el-input>
                </el-form-item>
                <span class="symbol input-after">RMB/ </span>
                <el-form-item label="偏远费(单位)"
                              class="hide-label">
                  <el-select v-model="addedServiceList[index].priceUnit"
                             disabled
                             class="mini-select-width"
                             placeholder="单位">
                    <el-option
                      v-for="(item, index) in priceUnitList"
                      :key="index"
                      :label="item.namec"
                      :value="item.namec"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <!--大型包裹费-->
              <template v-if="item.code === 'FB021'">
                <span class="input-before">外箱尺寸单边大于</span>
                <el-form-item label="大型包裹尺寸(拒收阈值)"
                              class="hide-label">
                  <el-input v-model="addedServiceList[index].chargeLimit"
                            disabled
                            class="edit-form__input3"
                            placeholder="请输入"></el-input>
                </el-form-item>
                <span class="symbol input-after">拒收</span>
                <br/>
                <span class="input-before">外箱尺寸单边大于</span>
                <el-form-item label="大型包裹尺寸(大于)"
                              class="hide-label">
                  <el-input v-model="addedServiceList[index].chargeFrom"
                            disabled
                            class="edit-form__input3"
                            placeholder="请输入"></el-input>
                </el-form-item>
                <span class="symbol input-after">CM，</span>
                <span class="symbol input-after">小于</span>
                <el-form-item label="大型包裹尺寸(小于)"
                              class="hide-label">
                  <el-input v-model="addedServiceList[index].chargeTo"
                            disabled
                            class="edit-form__input4"
                            placeholder="请输入"></el-input>
                </el-form-item>
                <span class="symbol input-after">CM，</span>
                <span class="symbol input-after">加收</span>
                <el-form-item label="大型包裹费"
                              class="hide-label">
                  <el-input v-model="addedServiceList[index].price"
                            disabled
                            class="edit-form__input4"
                            placeholder="请输入"></el-input>
                </el-form-item>
                <span class="symbol input-after">RMB/件</span>
              </template>
              <!--二次送仓费-->
              <template v-if="item.code === 'FB022'">
                <el-form-item label="二次送仓费"
                              class="hide-label">
                  <el-input v-model="addedServiceList[index].price"
                            disabled
                            class="edit-form__input3"
                            placeholder="请输入"></el-input>
                </el-form-item>
                <span class="symbol input-after">RMB/ </span>
                <el-form-item label="二次送仓费(单位)"
                              class="hide-label">
                  <el-select v-model="addedServiceList[index].priceUnit"
                             disabled
                             class="mini-select-width"
                             placeholder="单位">
                    <el-option
                      v-for="(item, index) in priceUnitList"
                      :key="index"
                      :label="item.namec"
                      :value="item.namec"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </template>

            </div>
          </div>
          <br/>
        </template>
        <el-radio-group disabled v-model="data.isProductSurcharge"
                        class="radio-group-row">
          <el-radio :label="true">加收</el-radio>
          <el-radio :label="false">不加收</el-radio>
        </el-radio-group>
        <el-form-item label="产品附加费" label-position="left">
        </el-form-item>
      </div>
    </template>
  </el-form>
</template>

<script>
  import {baseDataAddedServiceList} from "@/components/QuotationManagement/components-productQuotation/productQuotation";
  export default {
    name: "viewAddedServiceSetting",
    props:{
      data:{
        type:Object,
      }
    },
    data(){
      return {
        /* 选择框 数据 */
        isPremiumList:[
          {name:'加收',id:1},
          {name:'不加收',id:2},
        ],
        priceUnitList:[{namec:'CBM',id:0},{namec:'KG',id:1},],
      }
    },
    methods:{
      /**
       *  将获取的 产品报价详情中的 quoteAttachPrice{} 处理返回可编辑的 addedServiceList[] 数据结构
       * @param target
       * @returns {*}
       */
      disposeFormQuoteAttachPriceToAddedServiceList(target = {}){
        let list = baseDataAddedServiceList();
        if(typeof target !== 'object' || target === null) return list;
        let defaultList = [].concat(target.chargeDTO,target.declarationDTO,target.detailDTO,target.lightDTO);
        defaultList.forEach(res=>{
          // res.feeitemid = res.feeitemid ? res.feeitemid.toString() : '';
          let item = list.find(item=>item.feeitemid === res.feeitemid);
          if(item){
            Object.assign(item,res,{name:item.name,code:item.code,});
          }
        });
        list.forEach(res=>{
          if(res.price) res.isPremium =1;
        });
        return list;
      },
    },
    computed:{
      addedServiceList(){
        return this.disposeFormQuoteAttachPriceToAddedServiceList(this.data.quoteAttachPrice);
      }
    }
  }
</script>

<style scoped lang="scss">
.view-quotation-details{
  /deep/ .el-form-item{
    margin-bottom: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/viewDetails/viewAddedServiceSetting.vue